import { cn } from "~/ui-rtk/utils/tailwind-utils"
import { ChevronRightIcon } from "@heroicons/react/24/outline"
import useDemoMode from "~/ui-rtk/hooks/demo-mode"

interface StepSelectorProps {
  selectedNodes: string[]
  visibleSteps: number
  onNavigateToStep: (stepNumber: number) => void
}

export default function StepSelector({
  selectedNodes,
  visibleSteps,
  onNavigateToStep,
}: StepSelectorProps) {
  const { isEnabled: isDemoEnabled } = useDemoMode()

  // Only show breadcrumbs for completed previous steps (before current visibleSteps)
  if (visibleSteps <= 1) return null

  const completedSteps = selectedNodes.slice(0, visibleSteps - 1)
  if (completedSteps.length === 0) return null

  return (
    <div className="flex items-center gap-1 flex-wrap">
      {completedSteps.map((pagePath, index) => {
        const stepNumber = index + 1
        return (
          <div key={stepNumber} className="flex items-center gap-1">
            {index > 0 && (
              <ChevronRightIcon className="w-4 h-4 text-system-gray-400 mx-1" />
            )}
            <button
              className={cn(
                "flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors",
                "bg-system-blue-700 border border-system-blue-600",
                "hover:bg-system-blue-600 text-white",
              )}
              onClick={() => onNavigateToStep(stepNumber)}
              title={`Go back to Step ${stepNumber}`}
            >
              <span className="text-system-gray-300">Step {stepNumber}:</span>
              <span
                className={cn(
                  "font-medium truncate max-w-[200px]",
                  isDemoEnabled && "blur-md",
                )}
              >
                {pagePath}
              </span>
            </button>
          </div>
        )
      })}
    </div>
  )
}
